import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledAlert = styled.div`
    padding: 22px;
    border: 1px solid ${COLORS.$tartRed};
    border-radius: 8px;
    background: ${COLORS.$tartRedLite};
`;
